import { IconCash, IconCpu, IconMessageChatbot } from "@tabler/icons-react";
import { StatCard } from "../../../../components/common/stat-card";
import { SectionCard } from "../../../../components/common/section-card";
import { ShimmerLoader } from "../../../../components/common/shimmer";
import type { AdminAiChatPartnerCost } from "../../../api_client";

function fmtUSD(n: number) {
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 })}`;
}

interface PartnerAiCostStripProps {
  data?: AdminAiChatPartnerCost | null;
  isLoading: boolean;
}

export function PartnerAiCostStrip({ data, isLoading }: PartnerAiCostStripProps) {
  if (isLoading) return <ShimmerLoader message="Loading AI usage…" />;
  if (!data || data.userId === null) return null;

  return (
    <SectionCard shadow title="AI chat usage">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          icon={<IconCash size={18} />}
          label="AI spend (30d)"
          value={fmtUSD(data.last30DaysCostUSD)}
          sub={`${fmtUSD(data.last7DaysCostUSD)} last 7d`}
        />
        <StatCard
          icon={<IconCash size={18} />}
          label="AI spend (all-time)"
          value={fmtUSD(data.totalCostUSD)}
        />
        <StatCard
          icon={<IconMessageChatbot size={18} />}
          label="AI messages"
          value={data.totalCalls.toLocaleString()}
        />
        <StatCard
          icon={<IconCpu size={18} />}
          label="Total tokens"
          value={data.totalTokens.toLocaleString()}
        />
      </div>
    </SectionCard>
  );
}
